<!--
 * @Description: 特材成品维护
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 14:58:37
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ 'arrowTransform': !showCardNav, 'arrowTransformReturn': showCardNav}">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block;margin-bottom: 10px;">
                <span style="margin-right: 12px;">特材成品名称</span>
                <el-input v-model="tableParam.productName" style="width: 200px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px;">
                <span style="margin-right: 12px;">成品型号</span>
                <el-input v-model="tableParam.type" style="width: 200px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px;">
                <span style="margin-right: 12px;">成品罐</span>
                <el-input v-model="tableParam.tank" style="width: 200px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='TIANJIA'))!==-1" size="small" class="bottom_all" style="margin-left: 0;" @click="tankListArrlist=[],addFromDate('添加')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
                添加
              </el-button>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='RIYONG'))!==-1" size="small" class="bottom_three" @click="Update(1)">
                <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px;"></i>
                启用
              </el-button>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='JINYONG'))!==-1" size="small" class="bottom_four" @click="Update(0)">
                <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px;"></i>
                禁用
              </el-button>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='CHENPINGUANWEIHU'))!==-1" size="small" class="bottom_all_two" style="margin-left: 12px" @click="maintenanceLookFun()">成品罐维护</el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label =='操作'?'right':false">
                  <template slot-scope="scope">
                    <span v-if="scope.row.enable == 0 && item.label == '状态'" style="color:#969799;">禁用</span>
                    <span v-if="scope.row.enable == 1 && item.label == '状态'" style="color:#00A754;">启用</span>
                    <span v-if="item.label == '操作'">
                      <el-dropdown :hide-on-click="false" trigger="click">
                        <el-button size="mini" class="bottom_one">更多</el-button>
                        <el-dropdown-menu slot="dropdown" style="text-align: left">
                          <!-- <el-dropdown-item>
                            <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='XIUGAI'))!==-1" class="bottom_one" style="margin:5px 0" size="mini" @click="updateFromDate(scope.row, '修改'),tankListArrShow(scope.row)">
                              <i class="icon iconfont iconicon_button_modification" style="font-size: 12px;"></i>
                              修改
                            </el-button>
                          </el-dropdown-item> -->
                          <el-dropdown-item>
                            <el-button class="bottom_one" style="margin:5px 0" size="mini" @click="deleteProduct(scope.row)">
                              删除
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='MEIRIPANDIAN'))!==-1" class="bottom_one" style="margin:5px 0" size="mini" @click="look3Fun(scope.row)">
                              每日盘点
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='PDJL'))!==-1" class="bottom_one" size="mini" style="margin:5px 0" @click="look4Fun(scope.row)">
                              盘点历史
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button class="bottom_one" size="mini" style="margin:5px 0" @click="look6Fun(scope.row)">
                              配比设置
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button class="bottom_one" size="mini" style="margin:5px 0" @click="look7Fun(scope.row)">
                              库存明细
                            </el-button>
                          </el-dropdown-item>
                          <!-- <el-dropdown-item>
                            <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='RUKU'))!==-1" class="bottom_one" size="mini" style="margin:5px 0" @click="look5Fun(scope.row)">
                              入库
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button class="bottom_one" size="mini" style="margin:5px 0" @click="setPrice(scope.row)">
                              价格设置
                            </el-button>
                          </el-dropdown-item> -->
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <span v-if="item.label !== '操作' && item.label !== '状态'">{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ total }}条</div>
              <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" style="padding: 20px;" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="companyId" :rules="[{required: true,message: '请选择所属单位',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">所属单位</span>
            <el-select ref="companyId" v-model="fromDate.companyId" placeholder="请选择" @change="fromDate.tankListArr=[],wasteListArr=[],$nextTick(()=>{fromDate.company = $refs.companyId.selectedLabel}),tankqueryPageFunList(fromDate.companyId)">
              <el-option v-for="item in companyIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productName" :rules="[{required: true,message: '请输入特材成品名称',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">特材成品名称</span>
            <el-input v-model="fromDate.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="type" :rules="[{required: true,message: '请输入成品型号',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">成品型号</span>
            <el-input v-model="fromDate.type" placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="tankListArr" :rules="[{required: true,message: '请选择成品罐',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">成品罐</span>
            <el-select ref="tankListArr" v-model="fromDate.tankListArr" multiple placeholder="请选择">
              <el-option v-for="item in tankListArrlist.filter(item=>item.tankType===2)" :key="item.id" :label="item.tankName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="wasteListArr" :rules="[{required: true,message: '请选择废料罐',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">废料罐</span>
            <el-select ref="wasteListArr" v-model="fromDate.wasteListArr" multiple placeholder="请选择">
              <el-option v-for="item in tankListArrlist.filter(item=>item.tankType===3)" :key="item.id" :label="item.tankName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="enable">
            <el-radio-group v-model="fromDate.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog=false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="look2Type" width="800px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">成品罐维护</span>
      <div class="dialoginfo">
        <div style="padding-bottom: 10px;">
          <el-button size="mini" class="bottom_all" style="margin-left: 0;position: relative;" @click="addItem('添加')">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
            添加
          </el-button>
          <span style="position: absolute;right: 40px;">
            成品罐名称：
            <el-input v-model="table2Param.tankName" size="mini" style="width: 130px;margin-right:10px;"></el-input>
            <el-button size="mini" class="bottom_all but1" @click="tankqueryPageFun()">搜索</el-button>
          </span>
        </div>
        <el-table ref="look2List" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="maintenanceList" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="company" label="公司" width="auto" align="center"></el-table-column>
          <el-table-column prop="code" label="成品罐编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="tankName" label="成品罐名称" width="auto" align="center"></el-table-column>
          <el-table-column label="类型" width="auto" align="center">
            <template slot-scope="scope">
              {{scope.row.tankType===2?'成品罐':'废料罐'}}
            </template>
          </el-table-column>
          <el-table-column prop="inventory" label="库存（吨）" width="auto" align="center"></el-table-column>
          <el-table-column prop="" label="操作" width="280" align="center">
            <template slot-scope="scope">
              <div class="table_link" style="width:75px;">
                <a :href="'/file/' +scope.row.codeUrl" download>下载</a>
              </div>
              <el-button class="bottom_one" size="mini" @click="addItem('修改',scope.row)">
                <i class="icon iconfont iconicon_button_modification" style="font-size: 12px;"></i>
                编辑
              </el-button>
              <el-button size="mini" class="bottom_two" @click="tankdeleteFun(scope.row.id)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px;"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ table2Param.total }}条</div>
            <el-pagination :current-page.sync="table2Param.page" :page-size="table2Param.pageSize" layout="prev, pager, next, jumper" :total="table2Param.total" @current-change="tankqueryPageFun()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look2Type=false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="look1Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{look1Form.tableName}}</span>
      <div class="dialoginfo">
        <el-form ref="look1Form" style="padding: 20px;" :inline="true" :model="look1Form" label-width="110px">
          <el-form-item prop="companyId" :rules="[{required: true,message: '请选择所属单位',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">所属单位</span>
            <el-select ref="company" v-model="look1Form.companyId" placeholder="请选择" @change="$nextTick(()=>{look1Form.company = $refs.company.selectedLabel})">
              <el-option v-for="item in companyIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="tankName" :rules="[{required: true,message: '请输入成品罐名称',trigger: 'blur',}]">
            <span slot="label" style="color:#FF0000 ;">成品罐名称</span>
            <el-input v-model="look1Form.tankName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="tankType" :rules="[{required: true,message: '请选择类型',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">类型</span>
            <el-select v-model="look1Form.tankType" placeholder="请选择">
              <el-option label="成品罐" :value="2"></el-option>
              <el-option label="废料罐" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="look1Form.tankType!==2" prop="inventory" :rules="[{required: true,message: '请输入库存',trigger: 'blur',}]">
            <span slot="label" style="color:#FF0000 ;">库存量</span>
            <el-input v-model="look1Form.inventory" type="Number" placeholder="请输入" clearable>
              <template slot="append">吨</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type=false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="tanksaveOrUpdateFun('look1Form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="look3Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">每日盘点</span>
      <div class="dialoginfo">
        <el-form ref="fromDate3" style="padding: 20px;" :inline="true" :model="fromDate3" label-width="110px">
          <el-form-item prop="id" :rules="[{required: true,message: '请选择成品罐',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">成品罐</span>
            <el-select ref="companyId" v-model="fromDate3.id" placeholder="请选择" @change="$nextTick(()=>{fromDate3.tankName = $refs.companyId.selectedLabel})">
              <el-option v-for="item in tankNameList" :key="item.id" :label="item.tankName" :value="item.id" @click.native="$nextTick(()=>{fromDate3.avgPrie = item.avgPrie})"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inventory" :rules="[{required: true,message: '请输入盘点库存',trigger: 'change',}]">
            <span slot="label" style="color:#FF0000 ;">盘点库存</span>
            <el-input v-model="fromDate3.inventory" placeholder="请输入" clearable><template slot="append">吨</template></el-input>
          </el-form-item>
          <el-form-item prop="checkTime" :rules="[{required: true,message: '请输入盘点时间',trigger: 'change',}]">
            <span slot="label" style="color:#FF0000 ;">盘点时间</span>
            <el-date-picker v-model="fromDate3.checkTime" type="datetime" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item prop="avgPrie" :rules="[{required: true,message: '请输入盘点价格',trigger: 'change',}]">
            <span slot="label" style="color:#FF0000 ;">盘点价格</span>
            <el-input v-model="fromDate3.avgPrie" placeholder="请输入" clearable><template slot="append">元</template></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look3Type=false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="tansaveOrUpdateFun('fromDate3')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="look4Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">盘点历史</span>
      <div class="dialoginfo">
        <el-table ref="look2List" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="list4" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="name" label="特材成品名称" width="auto" align="center"></el-table-column>
          <el-table-column prop="type" label="成品型号" width="auto" align="center"></el-table-column>
          <el-table-column prop="tankName" label="成品罐" width="auto" align="center"></el-table-column>
          <el-table-column prop="num" label="盘点库存(吨)" width="auto" align="center"></el-table-column>
          <el-table-column prop="createUserName" label="盘点人" width="auto" align="center"></el-table-column>
          <el-table-column prop="checkTime" label="盘点时间" width="auto" align="center"></el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ table4Param.total }}条</div>
            <el-pagination :current-page.sync="table4Param.page" :page-size="table4Param.pageSize" layout="prev, pager, next, jumper" :total="table4Param.total" @current-change="recordsqueryPageFun()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look4Type=false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="look5Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">入库</span>
      <div class="dialoginfo">
        <el-form ref="lookForm5" style="padding: 20px;" :inline="true" :model="lookForm5" label-width="110px">
          <el-form-item prop="id" :rules="[{required: true,message: '请选择成品罐',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">成品罐</span>
            <el-select ref="companyId" v-model="lookForm5.id" placeholder="请选择">
              <el-option v-for="item in tankNameList" :key="item.id" :label="item.tankName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inventory" :rules="[{required: true,message: '请输入盘点库存',trigger: 'change',}]">
            <span slot="label" style="color:#FF0000 ;">入库量</span>
            <el-input v-model="lookForm5.inventory" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look5Type=false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="tansaveOrUpdateFun2('lookForm5')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 配比设置 -->
    <el-dialog :visible.sync="look6Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">配比设置</span>
      <div class="dialoginfo">
        <div style="padding-bottom: 20px;">
          <el-button size="mini" class="bottom_all" style="margin-left: 0;position: relative;" @click="addItem2()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
            添加
          </el-button>
        </div>
        <el-table ref="mixtureRatio" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="mixtureRatioList" :height="screenHeight - 500" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="rawName" label="原物料" width="auto" align="center">
            <template slot-scope="scope">
              <el-select ref="raw" v-model="scope.row.specialMaterialsId" placeholder="请选择" style="width: 100%;" @change="selectChanelSel(scope.$index, scope.row.specialMaterialsId)">
                  <el-option v-for="item in specialList" :key="item.id" :label="item.rawtName" :value="item.id"></el-option>
                </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="mixtureRatio" label="配合比值" width="auto" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mixtureRatio" placeholder="请输入" style="width:90%;" type="text" @input="(v)=>(scope.row.mixtureRatio=v.replace(/[^\d.]/g,''))"><template slot="append">KG</template></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="deleteItem(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px;"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look6Type=false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="submitMixtureRatio()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 价格设置   -->
    <el-dialog v-dialogDrag :visible.sync="priceVisible" width="70%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">价格设置</span>
      <div class="dialoginfo">
        <el-form ref="priceRef" style="padding: 20px;" :inline="true" :model="priceForm" label-width="110px">
          <el-form-item prop="stationId" :rules="[{required: true,message: '请选择站点',trigger: 'change',}]">
            <span slot="label" style="color:  #FF0000 ;">站点</span>
            <el-select v-model="priceForm.stationId" placeholder="请选择">
              <el-option v-for="(item, index) in stationList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="money" :rules="[{required: true,message: '请输入价格',trigger: 'blur',}]">
            <span slot="label" style="color:#FF0000 ;">价格</span>
            <el-input v-model="priceForm.money" type="number" placeholder="请输入" clearable>
              <template slot="append">元/吨</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="startTime" :rules="[{required: true,message: '请选择时间',trigger: 'blur',}]">
            <span slot="label" style="color:#FF0000 ;">生效时间</span>
            <el-date-picker
              v-model="priceForm.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="bottom_all" @click="addSubmit">添加</el-button>
          </el-form-item>
        </el-form>
        <div>价格列表</div>
        <el-form style="padding: 20px;" :inline="true" label-width="110px">
          <el-form-item prop="id">
            <span slot="label">站点</span>
            <el-select v-model="stationId" placeholder="请选择">
              <el-option v-for="(item, index) in stationList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="bottom_all" @click="initPriceTable">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="priceDataSource" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="stationName" label="站点" width="auto" align="center"></el-table-column>
          <el-table-column prop="money" label="价格" width="auto" align="center"></el-table-column>
          <el-table-column prop="startTime" label="生效时间" width="auto" align="center"></el-table-column>
          <el-table-column label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-button class="bottom_all_two" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <el-pagination :current-page.sync="pricePage" layout="prev, pager, next" :total="priceTotal" @current-change="initPriceTable()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="priceVisible=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 库存明细   -->
    <el-dialog v-dialogDrag :visible.sync="look7Type" width="780px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">库存明细</span>
      <div class="dialoginfo">
        <div>
          <span>成品名称:{{show7Data.productName}}</span>
          <span style="margin-left:50px">本地原料罐:{{show7Data.tank}}</span>
        </div>
        <el-table ref="look2List" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%;margin-top:20px" :data="stockDetailList" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="createTime" label="库存更新时间" width="auto" align="center"></el-table-column>
          <el-table-column prop="dataType" label="更新类型" width="auto" align="center">
            <template slot-scope="scope">
              <span>{{['','生产入库','返料入库','特材过磅冲销','盘盈','特材过磅','调料生产','盘亏','生产入库冲销','调料生产入库冲销'][scope.row.dataType*1]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productTank" label="成品罐" width="auto" align="center"></el-table-column>
          <el-table-column prop="receipt" label="入库量(吨)" width="auto" align="center"></el-table-column>
          <el-table-column prop="outboundQuantity" label="出库量(吨)" width="auto" align="center"></el-table-column>
          <el-table-column prop="afterStock" label="当前库存量(吨)" width="auto" align="center"></el-table-column>
          <el-table-column prop="price" label="价格" width="auto" align="center"></el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ table7Param.total }}条</div>
            <el-pagination :current-page.sync="table7Param.page" :page-size="table7Param.pageSize" layout="prev, pager, next, jumper" :total="table7Param.total" @current-change="getstockDetail()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look7Type=false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  batchUpdateOrDelete,
  saveOrUpdate,
  tanksaveOrUpdateNew,
  tankqueryPage,
  tankdelete,
  tansaveOrUpdate,
  querySpecialList,
  saveMixtureRatio,
  // deleteMixtureRatio,
  queryMixtureRatioList,
  queryInventoryDetail,
  deleteProduct,
  inventoryProductTank,
  recordsqueryPage, savMoney, queryDataSource, deleteMoney
} from "@/api/smart/specialmaterial/product.js";
import { permissionsCompanyList, getUserAutList } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      UserInfo: '',
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete,
      saveOrUpdate: saveOrUpdate,
      pickerOptions: {
        disabledDate(time) {
          //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() > Date.now();
        }
      },
      priceForm: {},
      /*表格数据*/
      table: [
        {
          label: "特材成品编码",
          width: "120",
          prop: "code",
          status: true,
        },
        {
          label: "所属单位",
          width: "130",
          prop: "company",
          status: true,
        },
        {
          label: "特材成品名称",
          width: "130",
          prop: "productName",
          status: true,
        },
        {
          label: "成品型号",
          width: "auto",
          prop: "type",
          status: true,
        },
        {
          label: "成品罐",
          prop: "tank",
          status: true,
        },
        {
          label: "废料罐",
          prop: "wasteTank",
          status: true,
        },
        {
          label: "库存量(吨)",
          width: "auto",
          prop: "inventory",
          status: true,
        },
        {
          label: "状态",
          width: "100",
          prop: "",
          status: true,
        },
        {
          label: "更新时间",
          width: "135",
          prop: "updateTime",
          status: true,
        },
        {
          label: "操作",
          width: "100",
          prop: "",
          status: true,
        },
      ],
      fromDate: {
        tankListArr: [],
        wasteListArr: [],
        companyId: '',
        productName: '',
        type: '',
        tankList: [],
        wasteList: [],
        enable: 1,
        dataType: 2,
      },
      companyIdList: [],
      tankListArrlist: [],
      look1Type: false,
      look1Form: {
        company: '',
        companyId: '',
        tableName: '添加',
        tankType: 2,
        tankName: '',
        inventory: '',
        id: ''
      },
      look2Type: false,
      table2Param: {
        tankName: '',
        tankType: 4,
        page: 1,
        pageSize: 10,
        total: 0
      },
      maintenanceList: [],
      look3Type: false,
      fromDate3: {
        id: '',
        inventory: '',
        checkTime: '',
        avgPrie:'',
        operation: 1,
      },
      tankNameList: [],
      look4Type: false,
      list4: [],
      table4Param: {
        dataId: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      look5Type: false,
      lookForm5: {
        id: '',
        inventory: ''
      },
      look6Type: false,
      lookForm6: {
        id: '',
      },
      look7Type: false,
      table7Param: {
        materialsProductId: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      show7Data:{
        productName:"",
        tank:""
      },
      specialList: [],
      mixtureRatioList: [],
      delMixtureRatioList: [],
      stockDetailList:[],//库存明细列表
      specialProductId: null,
      istype: false,
      materialsProductId: '',
      priceVisible: false,
      stationList: [],
      priceDataSource: [],
      priceTotal: 0,
      pricePage: 1,
      stationId: '',
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companyIdList = await permissionsCompanyList();
    this.stationList = await getUserAutList(true);
    this.tableParam = { ...this.tableParam, code: "", tank: '', supplierType: "", dataType: 2 };
    this.gettableData();
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    handleDelete (data) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        deleteMoney({id: data.id}).then(res => {
          if (res.code === 1001) {
            this.$message.success('删除成功')
            this.initPriceTable();
          }
        })
      }).catch(() => {
      });
    },
    addSubmit () {
      this.$refs.priceRef.validate((valid) => {
        if (valid) {
          const params = {
            ...this.priceForm,
            stationName: this.stationList.find(item => this.priceForm.stationId === item.id).name,
            materialsProductId: this.materialsProductId,
          }
          savMoney(params).then(res => {
            if (res.code === 1001) {
              this.$message.success('新增成功');
              this.initPriceTable();
            }
          })
        }
      })
    },
    initPriceTable () {
      const params = {
        stationId: this.stationId,
        page: this.pricePage,
        pageSize: 10,
        materialsProductId: this.materialsProductId,
      }
      queryDataSource(params).then(res => {
        if (res.code === 1001) {
          this.priceDataSource = res.data.data;
          this.priceTotal = res.data.totalRows;
        }
      })
    },
    /**入库提交 */
    tansaveOrUpdateFun2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let inventory = this.tankNameList.find((res) => this.lookForm5.id == res.id).inventory
          this.lookForm5.inventory = Number(this.lookForm5.inventory) + Number(inventory)
          tansaveOrUpdate(this.lookForm5).then((res) => {
            if (res.code == 1001) {
              this.look5Type = false
              this.gettableData();
            }
          })
        } else {
          return false;
        }
      });
    },
    /**点开入库 */
    look5Fun(e) {
      this.look5Type = true
      this.$nextTick(() => {
        this.$refs.lookForm5.resetFields()
      })
      this.tankNameList = []
      let arr = e.tankId.split(',')
      tankqueryPage({ tankType: 2, companyId: e.companyId, }).then((res) => {
        arr.forEach((v) => {
          let obj = res.data.data.find((res) => v == res.id)
          if (obj) {
            this.tankNameList.push(obj)
          }
        })
      });
    },
    setPrice (data) {
      this.priceVisible = true;
      this.materialsProductId = data.id;
      this.initPriceTable();
    },
    /* 配比设置 */
    look6Fun(e) {
      this.look6Type = true
      this.delMixtureRatioList = []
      queryMixtureRatioList({specialProductId: e.id}).then(res => {
        if(res.code == 1001) {
          this.mixtureRatioList = res.data
        }
      })
      this.specialProductId = e.id
      this.querySpecialList(e.companyId)
    },
    /*库存明细 */
    look7Fun(e) {
      this.look7Type = true
      this.table7Param.materialsProductId = e.id
      this.show7Data.productName = e.productName
      this.show7Data.tank = e.tank
      this.getstockDetail()
    },
    getstockDetail(){
      queryInventoryDetail(this.table7Param).then(res => {
        if(res.code == 1001) {
          this.stockDetailList = res.data.data
          this.table7Param.total = res.data.totalRows
        }
      })
    },
    querySpecialList(id) {
      querySpecialList({companyId: id}).then(res => {
        if(res.code == 1001) {
          this.specialList = res.data
        }
      })
    },
    submitMixtureRatio() {
      this.type = false
      console.log(this.mixtureRatioList);
      this.mixtureRatioList.forEach((v) => {
        if(!v.operationType) {
          v.operationType = 2
        }
        if (v.specialMaterialsId == null || v.mixtureRatio == null) {
          this.type = true
        }
      })
      if ([...new Set(this.mixtureRatioList.map((item) => item.specialMaterialsId))].length < this.mixtureRatioList.length) {
        this.$message({
          message: '原物料不能重复',
          type: 'warning'
        });
        return
      }
      if (this.type) {
        this.$message({
          message: '表格信息未填写完整！',
          type: 'warning'
        });
        return
      }
      saveMixtureRatio([...this.mixtureRatioList, ...this.delMixtureRatioList]).then(res => {
        if(res.code == 1001) {
          this.look6Type = false
          this.$message({
            message: '添加成功',
            type: 'success'
          });
        }
      })
    },
    deleteItem(index) {
      if (this.mixtureRatioList[index].id) {
        this.mixtureRatioList[index].operationType = 0
        this.delMixtureRatioList.push(this.mixtureRatioList[index])
        this.mixtureRatioList.splice(index, 1)
      } else {
        this.mixtureRatioList.splice(index, 1)
      }
    },
    selectChanelSel(index, id) {
      if(this.mixtureRatioList[index].id) {
        this.mixtureRatioList[index].operationType = 2
      }
      this.specialList.forEach(item => {
        if(item.id == id){
          this.mixtureRatioList[index].rawName = item.rawtName
          this.mixtureRatioList[index].specialProductId = this.specialProductId
        }
      })
    },
    /**盘点历史 */
    look4Fun(e) {
      console.log(e);
      this.look4Type = true
      this.table4Param.dataId = e.id
      this.recordsqueryPageFun()
    },
    /**盘点记录 */
    recordsqueryPageFun() {
      recordsqueryPage(this.table4Param).then((res) => {
        this.list4 = res.data.data
        this.table4Param.total = res.data.totalRows
      })
    },
    /**每日盘点 */
    tansaveOrUpdateFun(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          inventoryProductTank(this.fromDate3).then((res) => {
            if (res.code == 1001) {
              this.look3Type = false
              this.gettableData();
            }
          })
        } else {
          return false;
        }
      });
    },
    /**点开每日盘点 */
    look3Fun(e) {
      this.look3Type = true
      this.$nextTick(async () => {
        this.$refs.fromDate3.resetFields()
        this.fromDate3.productId = e.id
        this.fromDate3.productType = e.type
        this.fromDate3.productName = e.productName
        this.tankNameList = []
        let arr = e.tankId.split(',')
        await this.tankqueryPageFunList(e.companyId, e.id)
        arr.forEach((item) => {
          let obj = this.tankListArrlist.find((items) => item === items.id);
          if (obj) {
            this.tankNameList.push(obj)
          }
        })
      })
    },
    /**点修改 */
    tankListArrShow(e) {
      this.fromDate.productId = e.id
      this.fromDate.companyIdCopy = e.companyId
      this.tankqueryPageFunList(e.companyId, e.id)
      this.fromDate.tankListArr = [];
      this.fromDate.wasteListArr = [];
      e.tankId?.split(',').forEach((v) => {
        this.fromDate.tankListArr.push(v)
      })
      e.wasteTankId?.split(',').forEach((v) => {
        this.fromDate.wasteListArr.push(v)
      })
    },
    /**特材成品维护-删除 */
    deleteProduct(e) {
      this.$confirm('此操作将执行删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        deleteProduct({ id: e.id }).then((res) => {
          if (res.code == 1001) {
            this.gettableData();
          }
        })
      }).catch(() => { });
    },
    /**成品罐维护-删除 */
    tankdeleteFun(id) {
      this.$confirm('此操作将执行删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        tankdelete({ id: id }).then((res) => {
          if (res.code == 1001) {
            this.tankqueryPageFun()
          }
        })
      }).catch(() => { });
    },
    /**成品罐维护-添加 */
    tanksaveOrUpdateFun(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let companyList = this.companyIdList.filter(item => item.id === this.look1Form.companyId)
          if(companyList) {
            this.look1Form.company = companyList[0].name;
          }
          if(this.look1Form.tankType == 2) {
            this.look1Form.inventory = 0
          }
          tanksaveOrUpdateNew(this.look1Form).then((res) => {
            if (res.code == 1001) {
              this.look1Type = false
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.tankqueryPageFun()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**特材罐维护查询 */
    tankqueryPageFun() {
      tankqueryPage(this.table2Param).then((res) => {
        this.maintenanceList = res.data.data
        this.table2Param.total = res.data.totalRows
        this.gettableData();
      })
    },
    /**添加或修改 */
    addItem(name, e) {
      this.look1Type = true
      this.look1Form.tableName = name
      this.$nextTick(() => {
        this.$refs.look1Form.resetFields();
        this.look1Form.id = ''

        if (e) {
          this.look1Form.tankName = e.tankName
          this.look1Form.inventory = e.inventory
          this.look1Form.id = e.id
          this.look1Form.companyId = e.companyId
        }
      })
    },
    addItem2() {
      this.mixtureRatioList.push({
        specialMaterialsId: null,
        specialProductId: null,
        rawName: null,
        mixtureRatio: null,
        operationType: 1,
      })
    },
    /**成品罐维护 */
    maintenanceLookFun() {
      this.look2Type = true
      this.tankqueryPageFun()
    },
    /**添加提交 */
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate((valid) => {
        if (valid) {
          let companyList = this.companyIdList.filter(item => item.id === this.fromDate.companyId)
          if(companyList) {
            this.fromDate.company = companyList[0].name;
          }
          this.fromDate.tankList = []
          this.fromDate.wasteList = []
          this.fromDate.tankListArr.forEach((v) => {
            let item = this.tankListArrlist.find((e) => e.id == v)
            this.fromDate.tankList.push({ id: item.id, tankName: item.tankName, inventory: item.inventory })
          })
          this.fromDate.wasteListArr.forEach((v) => {
            let item = this.tankListArrlist.find((e) => e.id == v)
            this.fromDate.wasteList.push({ id: item.id, tankName: item.tankName, inventory: item.inventory })
          })
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    init() {
      /*重置数据*/
      this.tableParam.productName = "";
      this.tableParam.type = "";
      this.tableParam.tank = "";
      this.gettableData();
    },
    /**查询成品罐 */
    async tankqueryPageFunList(companyId, productId) {
      if (!productId && this.fromDate.companyIdCopy == companyId) {
        productId = this.fromDate.productId
      }
      await tankqueryPage({page:1,pageSize: 1000 ,companyId: companyId, productId: productId, binding: 0, tankType: 4 }).then((res) => {
        this.tankListArrlist = res.data.data;
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  .el-input,
  .el-select {
    width: 280px;
  }
}
.table_link {
  display: inline-block;
  width: 110px;
  margin: 0 10px 0 0;
  border: $bg_color 1px solid;
  color: $bg_color;
  border-radius: 3px;
  font-size: 14px;
  height: 30px;
  background: #ffffff;
  a {
    display: inline-block;
    line-height: 29.31px;
    color: $bg_color;
    text-decoration: none;
    font-size: 14px;
  }
}
</style>
